module.exports = __webpack_public_path__ + "static/media/2-3.68df8394.jpg";